export default "__VITE_ASSET__DC3uOMr2__"